import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CONTENT } from "@/content";

const L = CONTENT.legal;

export default function Legal() {
  useEffect(() => {
    const prev = document.title;
    document.title = L.pageTitle;
    return () => { document.title = prev; };
  }, []);
  return (
    <main className="page reader" data-testid="legal-page">
      <header className="journey-head">
        <h1 className="heart-title" data-testid="legal-title">{L.pageTitle}</h1>
      </header>
      {L.sections.map((s, i) => (
        <section key={s.title} className="nb-card legal-card" data-testid={`legal-section-${i + 1}`}>
          <h2 className="panel-title">{s.title}</h2>
          {s.paragraphs.map((p, j) => <p key={j} className="reader-message">{p}</p>)}
        </section>
      ))}
      <Link to={L.contactTo} className="nb-btn form-open" data-testid="legal-contact-button">{L.contactButton}</Link>
    </main>
  );
}
